<template>
	<transition name="slide-fade" mode="out-in">
    	<div class="contain bg-gray">
		    <div class="flex-row2">
		        <div class="mGT-top flex-row4" :class="{'mGT-top-active':usedFlag=='0'}" @click="clickNotUsed()">未使用</div>
		        <div class="mGT-top flex-row4" :class="{'mGT-top-active':usedFlag=='1'}"  @click="clickUsed()">已使用</div>
		    </div>
	        <div class="height-56 flex-row1 padding-lr-24" v-show="usedFlag=='0'">
	        	<span  @click="showCityFlag=true">{{city}}<span class="opacity-0">空</span></span>
	            <img class="width-12 margin-b--2"  @click="showCityFlag=true" src="../../../images/icon/arrow-triangle-down.png">
	        </div>
	        <mt-popup v-model="showCityFlag"  
	        		  popup-transition="popup-fade" 
	        		  position="bottom"  
	        		  style="width: 100%;" >
	        		  <div class="picker-toolbar border-b-1">
	        		  	<span class="mint-datetime-action mint-datetime-cancel" @click="showCityFlag=false">取消</span> 
	        		  	<span class="mint-datetime-action mint-datetime-confirm" @click="cityPickerConfirm()">确定</span></div>
			    <mt-picker :slots="citySlots" 
			    		   value-key="name" 
			    		   @change="onCityChange">
			    </mt-picker>
			</mt-popup>
		    <div class="padding-lr-24 color-orange" v-show="!usedFlag && !ticketFlag">该地区近期暂无线下活动</div>
		    <div v-show="usedFlag=='0' && ticketFlag">
			    <div class="mGT-ticket-bg flex-row1 mGT-notused" v-for="(item,index) in unusedList" :key="index" @click="clickTicket(item)">
			        <div class="width-136 text-c color-fff">
			            <div class="size-16">{{item.couponName}}</div>
			            <div>线下礼品</div>
			        </div>
			        <div class="width-196 padding-l-12">
			            <div class="padding-b-16">广联达线下活动广材体验区会员专属礼品券({{city}})</div>
			            <div class="color-999">剩余：{{item.remain}}张</div>
			            <div class="color-999">有效期：{{item.endTime}}</div>
			        </div>
			    </div>
			</div>
		    <div class="padding-lr-24" v-show="usedFlag=='0'">
		        <div class="color-999 size-16 flex-row1 height-56">规则</div>
		        <div >
		            <div class="position-a">1、</div>
		            <div class="padding-l-16">定制礼品为广材网VIP企业特权，按企业等级获得。</div>
		        </div>
		        <div>
		            <div class="position-a">2、</div>
		            <div class="padding-l-16">仅限在参与所有线下广联达活动现场领取。</div>
		        </div>
		        <div >
		            <div class="position-a">3、</div>
		            <div class="padding-l-16">现场向广联达工作人员出示礼品券二维码即可兑换礼品一份。</div>
		        </div>
		        <div >
		            <div class="position-a">4、</div>
		            <div class="padding-l-16">每日限领1张礼品券，当天有效，不限领取次数。</div>
		        </div>
		    </div>
		    <div  v-show="usedFlag=='1'">
			    <div class="mGT-ticket-bg flex-row1 mGT-used" v-for="(item,index) in usedList" :key="index">
			        <div class="width-136 text-c color-fff">
			            <div class="size-16">{{item.couponName}}</div>
			            <div>线下礼品</div>
			        </div>
			        <div class="width-196 padding-l-12">
			            <div class="padding-b-24">广联达线下活动广材体验区会员专属礼品券({{item.branch}})</div>
			            <div class="color-999 margin-t-8">有效期：{{item.endTime}}</div>
			        </div>
			    </div>
			</div>
		    <!-- 弹框 -->
		    <div class="m-fixed" v-show="codeFlag">
		        <div class="m-fixedbox text-c">
		        	<div class="flex-row4 height-56">请出示二维码给工作人员</div>
		        	<div id="qrcode" ref="qrcode" class="flex-row4"></div>
		            <div class="btn-fixed1" @click="codeFlag=false">
		                确定
		            </div>
		        </div>
		    </div>
    	</div>
	</transition>
</template>

<style lang="less" scoped>
@import "../../../style/variable.less";
@import "style.less";
</style>

<script>
module.exports = require("./index.js")
</script>